var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91683 11.5001C1.91683 16.7709 6.22933 21.0834 11.5002 21.0834C16.771 21.0834 21.0835 16.7709 21.0835 11.5001C21.0835 6.22925 16.771 1.91675 11.5002 1.91675C6.22933 1.91675 1.91683 6.22925 1.91683 11.5001Z",
    stroke: "#2A2D34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4998 11.4956L11.4998 11.5042",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71681 15.08C8.48215 15.08 8.28481 15.016 8.12481 14.888C7.97548 14.7493 7.89548 14.5733 7.88481 14.36C7.88481 14.1467 7.97548 13.9227 8.15681 13.688L10.7488 10.488V11.432L8.31681 8.44C8.12481 8.20533 8.03415 7.98133 8.04481 7.768C8.05548 7.55467 8.13548 7.384 8.28481 7.256C8.44481 7.11733 8.64215 7.048 8.87681 7.048C9.12215 7.048 9.32481 7.09067 9.48481 7.176C9.65548 7.26133 9.81015 7.39467 9.94881 7.576L11.8688 10.04H11.1648L13.1008 7.576C13.2501 7.39467 13.4048 7.26133 13.5648 7.176C13.7248 7.09067 13.9221 7.048 14.1568 7.048C14.4021 7.048 14.5995 7.11733 14.7488 7.256C14.8981 7.39467 14.9728 7.57067 14.9728 7.784C14.9835 7.99733 14.8928 8.22133 14.7008 8.456L12.2848 11.416V10.52L14.8768 13.688C15.0688 13.912 15.1595 14.1307 15.1488 14.344C15.1381 14.5573 15.0528 14.7333 14.8928 14.872C14.7435 15.0107 14.5461 15.08 14.3008 15.08C14.0661 15.08 13.8688 15.0373 13.7088 14.952C13.5488 14.8667 13.3941 14.7333 13.2448 14.552L11.1648 11.928H11.8368L9.77281 14.552C9.63415 14.7227 9.48481 14.856 9.32481 14.952C9.16481 15.0373 8.96215 15.08 8.71681 15.08Z",
    fill: "#2A2D34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.2f870428e66c7580b1ddfe0fe5de01ac.svg";
export { ForwardRef as ReactComponent };